import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Billing Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Billing Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/billing',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
